import { jsxs, jsx } from "react/jsx-runtime";
import { Heading, Paragraph } from "@zillow/constellation-10";
const RatesArticle = ({
  article
}) => {
  return /* @__PURE__ */ jsxs("article", { children: [
    /* @__PURE__ */ jsx(Heading, { level: 3, textStyle: "heading-xs", children: article == null ? void 0 : article.title }),
    article == null ? void 0 : article.paragraphs.map((p) => /* @__PURE__ */ jsx(Paragraph, { css: {
      marginTop: "loose"
    }, children: p }, p)),
    /* @__PURE__ */ jsxs(Paragraph, { textStyle: "body-xs", css: {
      marginTop: "default"
    }, children: [
      "Last updated: ",
      article == null ? void 0 : article.date
    ] })
  ] });
};
export {
  RatesArticle
};
